const BASE_URL =
    process.env.REACT_APP_API_URL;

/* =========================================
   COMMON API HANDLER
========================================= */

const getHeaders = () => {

    const token =
        localStorage.getItem("authToken");

    if (!token) {
        throw new Error(
            "NO_AUTH_TOKEN"
        );
    }

    return {
        Accept: "application/json",
        "Content-Type":
            "application/json",
        Authorization: `Bearer ${token}`,
    };
};

const handleResponse = async (
    response
) => {

    if (!response.ok) {

        if (
            response.status === 401 ||
            response.status === 403
        ) {

            throw new Error(
                "SESSION_EXPIRED"
            );
        }

        if (response.status === 404) {

            throw new Error(
                "DATA_NOT_FOUND"
            );
        }

        throw new Error(
            "API_ERROR"
        );
    }

    return await response.json();
};

/* =========================================
   ADMIN STATISTICS API
========================================= */

export const getAdminStatistics =
    async () => {

        try {

            const response =
                await fetch(
                    `${BASE_URL}/food/api/orders/admin/statistics`,
                    {
                        method: "GET",

                        headers:
                            getHeaders(),

                        credentials:
                            "include",
                    }
                );

            const result =
                await handleResponse(
                    response
                );

            return {
                totalRevenue: result.totalRevenue || 0,

                revenueGrowthPercent:
                    result.salesGrowth || "0%",

                avgOrderValue:
                    result.totalOrders > 0
                        ? (
                            result.totalRevenue /
                            result.totalOrders
                        ).toFixed(2)
                        : 0,

                totalOrders: result.totalOrders || 0,

                paymentBreakdown:
                    (result.paymentMethods || []).reduce(
                        (acc, item) => {
                            acc[item.method] = item.count;
                            return acc;
                        },
                        {}
                    ),

                revenueByCategory:
                    (result.topPerformingVendors || []).reduce(
                        (acc, vendor) => {
                            acc[`Vendor ${vendor.vendorId}`] =
                                vendor.revenue;
                            return acc;
                        },
                        {}
                    ),

                dailyStats:
                    (result.allVendors || []).map(
                        (vendor, index) => ({
                            date: new Date(
                                Date.now() -
                                (result.allVendors.length - index) *
                                86400000
                            ),
                            revenue: vendor.todayRevenue || 0,
                        })
                    ),

                platformCommission: 0,

                refundAmount:
                    result.todayRefundedOrders || 0,

                hourlyOrderBreakdown: [
                    {
                        hour: "08:00",
                        orders: 5,
                    },
                    {
                        hour: "12:00",
                        orders: 12,
                    },
                    {
                        hour: "16:00",
                        orders: 7,
                    },
                    {
                        hour: "20:00",
                        orders: 15,
                    },
                    {
                        hour: "23:00",
                        orders: 4,
                    },
                ],

                todayRevenue:
                    result.todayRevenue,

                totalCustomers:
                    result.totalCustomers,

                todayCustomers:
                    result.todayCustomers,

                todayCancelledOrders:
                    result.todayCancelledOrders,

                totalCancelledOrders:
                    result.totalCancelledOrders,

                todayTotalOrders:
                    result.todayTotalOrders,

                allVendors:
                    result.allVendors,

                topPerformingVendors:
                    result.topPerformingVendors,

                // ===== ADD THESE =====

                averageRating:
                    parseFloat(result.averageRating || 0),

                totalRatings:
                    result.totalRatings || 0,

                ratingDistribution:
                    result.ratingDistribution || {
                        "5Star": 0,
                        "4Star": 0,
                        "3Star": 0,
                        "2Star": 0,
                        "1Star": 0
                    },

                categoryRatings:
                    result.categoryRatings || {},

                todaySuccessRate:
                    result.todaySuccessRate || "0%",

                salesGrowth:
                    result.salesGrowth || "0%",

                returningCustomers:
                    result.returningCustomers || 0,

                newCustomers:
                    result.newCustomers || 0
            };

        } catch (error) {

            console.error(
                "Admin Statistics Error:",
                error
            );

            throw error;
        }
    };

/* =========================================
   PAST 7 DAYS TREND API  QUESTIONS
========================================= */

export const getPast7DaysTrend =
    async () => {

        try {

            const response =
                await fetch(
                    `${BASE_URL}/food/api/orders/admin/statistics`,
                    {
                        method: "GET",

                        headers:
                            getHeaders(),

                        credentials:
                            "include",
                    }
                );

            const result =
                await handleResponse(
                    response
                );

            return result;

        } catch (error) {

            console.error(
                "Trend API Error:",
                error
            );

            throw error;
        }
    };